function getRequestForm(item) {
  return item.closest('.resy-form');
}

function getRequestURL(currentForm) {
  let date = currentForm.querySelector('input[name=date]').value;
  const time = currentForm.querySelector('select[name=time]').value;
  const seats = currentForm.querySelector('select[name=seats]').value;
  const action = currentForm.getAttribute('action');
  const newDate = new Date(date);
  const y = newDate.getFullYear();
  // eslint-disable-next-line prefer-template
  const d = ('0' + newDate.getDate()).slice(-2);
  // eslint-disable-next-line prefer-template
  const m = ('0' + (newDate.getMonth() + 1)).slice(-2);

  date = `${y}-${m}-${d}`;

  return `${action}?&date=${date}&seats=${seats}&time=${time}`;
}

function getRequest(url) {
  const resyWindow = window.open(url, '_blank');

  if (resyWindow) {
    resyWindow.focus();
  }

  return false;
}

function submitCallback(item) {
  const currentForm = getRequestForm(item);
  const requestURL = getRequestURL(currentForm);
  getRequest(requestURL);
  return false;
}

const submits = window.document.querySelectorAll('.resy-submit');

submits.forEach((item) => {
  item.addEventListener('click', (event) => {
    event.preventDefault();
    submitCallback(item);
  });

  item.addEventListener('keydown', (event) => {
    const code = (event.keyCode ? event.keyCode : event.which);
    if (code === 13) {
      event.preventDefault();
      submitCallback(item);
    }
  });
});
